import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

export default class Rate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rated: false,
            rating: false
        }
    }

    rate(rating) {
        let data = this.props.qs;
        data["rate"] = rating;
        this.props.mixpanel.track("Rated Search", data);
        this.setState({rating: true}, () => {
            setTimeout(() => {
                this.setState({rated: true})
            }, 450)
        });
    }

    render() {
        return(
            <div class={cx("rate-container", {"visible": this.props.visible})}>
                {this.state.rated &&
                    <div class={cx("rateWrapper", "appearing")}>
                        <p>Thanks for rating!</p>
                    </div>
                }
                {!this.state.rated && 
                    <div class={cx("rateWrapper", {"removing": this.state.rating})}>
                        <p>Rate this Search</p>
                        <div class={cx("rates")}>
                            <div class={cx("rate")} onClick={() => {
                                this.rate(1)
                            }}>
                                😡
                            </div>

                            <div class={cx("rate")} onClick={() => {
                                this.rate(2)
                            }}>
                                😔
                            </div>

                            <div class={cx("rate")} onClick={() => {
                                this.rate(3)
                            }}>
                                😐
                            </div>

                            <div class={cx("rate")} onClick={() => {
                                this.rate(4)
                            }}>
                                🙂
                            </div>

                            <div class={cx("rate")} onClick={() => {
                                this.rate(5)
                            }}>
                                😁
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/search/rate/index.js